export var Endpoints;
(function (Endpoints) {
    Endpoints["Login"] = "/login";
    Endpoints["Register"] = "/register";
    Endpoints["CustomAttrsUrl"] = "/update-profile/custom-attributes/{UUID}";
    Endpoints["InvoicePath"] = "/orders/{UUID}";
    Endpoints["MarketCustomAttrsUrl"] = "/custom-attributes";
    Endpoints["StoreAddressesUrl"] = "/update-profile/addresses/{UUID}";
    Endpoints["UpdateAddressUrl"] = "/update-profile/addresses/{UUID}/{ADDRESS_ID}";
    Endpoints["UpdateDefaultBillingAddress"] = "/update-profile/addresses/{UUID}/{ADDRESS_ID}/set-default-billing";
    Endpoints["UpdateDefaultShippingAddress"] = "/update-profile/addresses/{UUID}/{ADDRESS_ID}/set-default-shipping";
    Endpoints["Validate"] = "/validate-session";
    Endpoints["ForgotPassword"] = "/forgot-password";
    Endpoints["ResetPassword"] = "/reset-consumer-password";
    // Profile endpoints
    Endpoints["ProfilePath"] = "/profile/{UUID}";
    Endpoints["Logout"] = "/logout";
    Endpoints["ChangePassword"] = "/consumers/{UUID}/change-password";
    Endpoints["UpdateEmail"] = "/request-update-email/{UUID}";
    Endpoints["VerifyEmailUpdate"] = "/verify-email-update";
    Endpoints["UpdatePhone"] = "/update-profile/phone/{UUID}";
    Endpoints["UpdateAv"] = "/profile/{UUID}/verify-age";
    Endpoints["VerifyPhone"] = "/get-verified-phone/{PHONE}";
    Endpoints["VerifyEmail"] = "/verify/{EMAIL}";
    Endpoints["UpdateProfile"] = "/update-profile/personal-details/{UUID}";
    Endpoints["GeneratePromoCode"] = "/consumers/{UUID}/generate-promo-code";
    Endpoints["CancelAccount"] = "/cancel-account/{UUID}";
    Endpoints["PasswordRequirements"] = "/password-requirements";
    Endpoints["Privacy"] = "/dsar-request";
    Endpoints["Wallet"] = "/profile/{UUID}/wallet";
})(Endpoints || (Endpoints = {}));
export var EvoEndpoints;
(function (EvoEndpoints) {
    EvoEndpoints["Login"] = "/users/authentication/sessions";
    EvoEndpoints["Register"] = "/users/register";
    EvoEndpoints["CustomAttrsUrl"] = "/users/{UUID}/custom-attributes";
    EvoEndpoints["InvoicePath"] = "/users/{UUID}/orders";
    EvoEndpoints["MarketCustomAttrsUrl"] = "/users/configuration";
    EvoEndpoints["StoreAddressesUrl"] = "/users/{UUID}/addresses";
    EvoEndpoints["UpdateAddressUrl"] = "/users/{UUID}/addresses/{ADDRESS_ID}";
    EvoEndpoints["UpdateDefaultBillingAddress"] = "/users/{UUID}/addresses/billing/{ADDRESS_ID}";
    EvoEndpoints["UpdateDefaultShippingAddress"] = "/users/{UUID}/addresses/shipping/{ADDRESS_ID}";
    EvoEndpoints["Validate"] = "/users/authentication/sessions/validate";
    EvoEndpoints["ForgotPassword"] = "/users/authentication/password/forget";
    EvoEndpoints["ResetPassword"] = "/users/authentication/password/change/{USER_TOKEN}";
    // Profile endpoints
    EvoEndpoints["ProfilePath"] = "/users/{UUID}/profile";
    EvoEndpoints["Logout"] = "/users/authentication/sessions";
    EvoEndpoints["ChangePassword"] = "/users/authentication/password/change";
    EvoEndpoints["UpdateEmail"] = "/users/{UUID}/profile/email/request-update";
    EvoEndpoints["VerifyEmailUpdate"] = "/users/profile/email";
    EvoEndpoints["UpdatePhone"] = "/users/{UUID}/profile/phone";
    EvoEndpoints["UpdateAv"] = "/users/{UUID}/av";
    EvoEndpoints["VerifyPhone"] = "/users/verify/{PHONE}";
    EvoEndpoints["VerifyEmail"] = "/users/verify/{EMAIL}";
    EvoEndpoints["UpdateProfile"] = "/users/{UUID}/profile";
    EvoEndpoints["GeneratePromoCode"] = "/users/{UUID}/coupons";
    EvoEndpoints["CancelAccount"] = "/users/{UUID}/cancel";
    EvoEndpoints["PasswordRequirements"] = "/users/configuration";
    EvoEndpoints["Privacy"] = "/users/privacy";
    EvoEndpoints["Consents"] = "/users/{UUID}/consents";
    EvoEndpoints["Wallet"] = "/users/{UUID}/profile/wallet";
})(EvoEndpoints || (EvoEndpoints = {}));
export var EndpointPlaceholders;
(function (EndpointPlaceholders) {
    EndpointPlaceholders["UUID"] = "{UUID}";
    EndpointPlaceholders["ADDRESS_ID"] = "{ADDRESS_ID}";
    EndpointPlaceholders["PHONE"] = "{PHONE}";
    EndpointPlaceholders["EMAIL"] = "{EMAIL}";
    EndpointPlaceholders["USER_TOKEN"] = "{USER_TOKEN}";
})(EndpointPlaceholders || (EndpointPlaceholders = {}));
//# sourceMappingURL=CasEndpoints.js.map